import { z } from 'zod';
import validations from 'utils/validations';

export const schema = z.object({
  instructions: z.array(z.object({
    accounting_id: validations.requiredString(''),
    amount: validations.requiredNumber(''),
    association_id: validations.requiredString(''),
    payment_id: validations.requiredString(''),
  })).min(1),
  authorization: z.array(z.string().email('')).min(1),
});
